
import { menuSections } from "@/components/sidebar/menu-categories/sections";
import { marketingBusinessItems } from "@/components/sidebar/menu-items";
import { seoItems } from "@/components/sidebar/menu-items";
import { productivityItems } from "@/components/sidebar/menu-items";
import { utilitiesItems } from "@/components/sidebar/menu-items";
import { accountItems } from "@/components/sidebar/menu-items";

export const generateToolRoutes = (): { [key: string]: string } => {
  const toolRoutes: { [key: string]: string } = {};

  // Add routes from all menu categories
  const allItems = [
    ...marketingBusinessItems,
    ...seoItems,
    ...productivityItems,
    ...utilitiesItems,
    ...accountItems
  ];

  allItems.forEach(item => {
    if (!item.adminOnly) {
      toolRoutes[item.title] = item.id;
    }
  });

  // Add explicit mappings for tools with exact names
  toolRoutes["EvoRate"] = "evorate";
  toolRoutes["ShortaTrack"] = "shortatrack";
  toolRoutes["CheckLista"] = "checklista";
  toolRoutes["FormuGen"] = "formugen";
  toolRoutes["QRna"] = "qrna";
  toolRoutes["PageSpeedCheck"] = "pagespeed-check";
  toolRoutes["CanvasBuilder"] = "canvasbuilder";
  toolRoutes["CompressaPic"] = "compressapic";
  toolRoutes["Planifica"] = "planifica";
  toolRoutes["ROIQuick"] = "roi-quick";
  toolRoutes["ProfitPilot"] = "profit-pilot";
  toolRoutes["EmailScore"] = "email-score";
  toolRoutes["BizNameGen"] = "biz-name-gen";
  toolRoutes["GenPersona"] = "gen-persona";
  toolRoutes["SnippetView"] = "snippet-view";
  toolRoutes["KeywordCheck"] = "keyword-check";
  toolRoutes["ToDoBoost"] = "todo-boost";
  toolRoutes["UTMagic"] = "utm-magic";
  toolRoutes["ConvertiCalc"] = "converticalc";
  toolRoutes["TabliWizz"] = "tabliwizz";
  toolRoutes["FairClick"] = "fairclick";
  toolRoutes["Mes Rapports"] = "mes-rapports";
  toolRoutes["QuizNGo"] = "quizngo";
  
  // Also add a special entry for the Welcome page
  toolRoutes["Accueil"] = "welcome";

  // Make sure Planifica appears in console for debugging
  console.log("All tool routes:", toolRoutes);

  return toolRoutes;
};

export const getToolRoute = (toolName: string): string => {
  const routes = generateToolRoutes();
  const route = routes[toolName];
  if (!route) {
    console.warn(`No route found for tool: ${toolName}`);
    return "/welcome";
  }
  return `/${route}`;
};
